// src/components/Signup.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { database, ref, push } from '../firebase'; // import Firebase DB functions
import './styles.css';

const Signup = () => {
  const [formData, setFormData] = useState({
    firstname: '',
    lastname: '',
    email: '',
    password: '',
    confirmpassword: '',
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Simple validation: Check if passwords match
    if (formData.password !== formData.confirmpassword) {
      alert('Passwords do not match.');
      return;
    }

    try {
      // Reference to 'users' node in DB
      const usersRef = ref(database, 'users');
      await push(usersRef, {
        firstname: formData.firstname,
        lastname: formData.lastname,
        email: formData.email,
        password: formData.password, // WARNING: Plaintext password - not safe for production!
      });

      alert('User registered successfully!');
      setFormData({
        firstname: '',
        lastname: '',
        email: '',
        password: '',
        confirmpassword: '',
      });
    } catch (error) {
      console.error('Error saving to Firebase:', error);
      alert('Registration failed. Please try again.');
    }
  };

  return (
    <div className="login-signup-bg">
      <div className="signup-container">
        <img
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwhhDo0NZ9iWcEgTHVMjJWGnWIOunvh-a0Pg&s"
          alt="Logo"
          style={{ height: 50, width: 50, margin: '0 auto', display: 'flex', justifySelf: 'center' }}
        />
        <h2>Sign Up</h2>
        <form onSubmit={handleSubmit}>
          <div className="name-group">
            <div className="form-group">
              <i className="fas fa-user"></i>
              <input
                type="text"
                placeholder="First Name"
                value={formData.firstname}
                onChange={(e) => setFormData({ ...formData, firstname: e.target.value })}
                required
              />
            </div>
            <div className="form-group">
              <i className="fas fa-user-tag"></i>
              <input
                type="text"
                placeholder="Last Name"
                value={formData.lastname}
                onChange={(e) => setFormData({ ...formData, lastname: e.target.value })}
                required
              />
            </div>
          </div>

          <div className="form-group">
            <i className="fas fa-envelope"></i>
            <input
              type="email"
              placeholder="Enter Email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              required
            />
          </div>

          <div className="form-group">
            <i className="fas fa-key"></i>
            <input
              type="password"
              placeholder="Enter Password"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              required
            />
          </div>

          <div className="form-group">
            <i className="fas fa-lock"></i>
            <input
              type="password"
              placeholder="Re-enter Password"
              value={formData.confirmpassword}
              onChange={(e) => setFormData({ ...formData, confirmpassword: e.target.value })}
              required
            />
          </div>

          <button type="submit" className="signup-button">
            Sign Up
          </button>
        </form>
        <p>
          Already have an account? <Link to="/login">Log In</Link>
        </p>
      </div>
    </div>
  );
};

export default Signup;
